import React from 'react';
import logo from "../movies-logo.jpg";
import {Link} from "react-router-dom";

function Navbar() {
  return (
    <div className="border flex items-center space-x-7 bg-gray-100 pl-5 relative">
     <Link to="/"> <img src={logo} alt="" className="h-20"></img> </Link>
      <div className='text-3xl font-bold'>Trending Movies</div>
      <div className="flex space-x-9 absolute top-3 right-3">
      <Link to="/" className="text-2xl font-bold text-white rounded-xl bg-blue-500 p-3 text-center w-[130px]">Movies</Link>
      <Link to="/fav" className="text-2xl rounded-xl bg-blue-500 font-bold text-white p-3">Favourites</Link>
      </div>
    </div>
  )
}

export default Navbar;
